import { useRef } from 'react';
import { useDialogA11y } from '../../hooks/useDialogA11y';

type Props = {
  open: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function ConfirmModal({ open, title='Confirm', message='', confirmText='Confirm', cancelText='Cancel', onConfirm, onCancel }: Props) {
  const ref = useRef<HTMLDivElement>(null);
  useDialogA11y(open, ref, onCancel);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[9000] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/70" onClick={onCancel} aria-hidden />
      <div ref={ref} role="alertdialog" aria-modal="true" aria-label={title || 'Confirm'} tabIndex={-1} className="relative z-10 w-full max-w-md rounded-2xl border border-neutral-800 bg-neutral-900 p-4 shadow-2xl outline-none">
        {title && <div className="text-brand font-medium mb-2">{title}</div>}
        {message && <div className="text-fg text-sm whitespace-pre-wrap">{message}</div>}
        <div className="mt-4 flex justify-end gap-2">
          <button className="px-3 py-2 rounded-xl border border-neutral-700 text-fg hover:bg-neutral-800/70" onClick={onCancel}>{cancelText}</button>
          <button className="px-3 py-2 rounded-xl border border-brand/60 bg-brand/20 text-brand hover:bg-brand/30" onClick={onConfirm}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
}
